module.exports = __webpack_public_path__ + "static/facebook-25880b65e89710aca311deb362a90add.jpg";